import React, { useContext, useEffect, useState } from 'react'
import {
  Alert,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import API from '../../../services/API'
import { BookingContext, SectionHeader } from './NewBooking'

// Optional NHS PTS-style eligibility questionnaire, shown to portal users
// only (§5.4). The outcome is stored on the booking for funding audit and
// never blocks the booking from being created — unanswered questions are
// just left out of the outcome calculation server-side.
const Eligibility = () => {
  const { formData, setFormData } = useContext(BookingContext)
  const [enabled, setEnabled] = useState(false)
  const [questions, setQuestions] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    API.get(
      '/settings?select=patientTransportSettings.booking.eligibilityScreeningEnabled%20patientTransportSettings.booking.eligibilityQuestions',
    )
      .then((res) => {
        if (res.status === 200) {
          const booking = res.data?.patientTransportSettings?.booking
          setEnabled(!!booking?.eligibilityScreeningEnabled)
          setQuestions((booking?.eligibilityQuestions || []).filter(Boolean))
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  const answers = formData?.eligibilityScreening?.answers || []

  const setAnswer = (question, value) => {
    setFormData((prev) => {
      const nextAnswers = (prev?.eligibilityScreening?.answers || []).filter(
        (a) => a.question !== question,
      )
      nextAnswers.push({ question, answer: value })
      return {
        ...prev,
        eligibilityScreening: {
          ...prev?.eligibilityScreening,
          answers: nextAnswers,
        },
      }
    })
  }

  if (loading || !enabled || !questions.length) return null

  return (
    <Box>
      <SectionHeader
        icon={<HealthAndSafetyIcon fontSize="small" />}
        title="Eligibility Screening"
      />
      <Alert severity="info" sx={{ mb: 2 }}>
        This helps us record whether the transport meets patient transport
        eligibility criteria for funding purposes. It does not affect whether
        the booking can be made.
      </Alert>
      <Stack spacing={2}>
        {questions.map((question) => (
          <Box key={question}>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              {question}
            </Typography>
            <RadioGroup
              row
              value={answers.find((a) => a.question === question)?.answer || ''}
              onChange={(e) => setAnswer(question, e.target.value)}
            >
              <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
              <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
            </RadioGroup>
          </Box>
        ))}
      </Stack>
    </Box>
  )
}

export default Eligibility
